import {
  Alert,
  Button,
  Card,
  CardContent,
  Container,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import API_BASE_URL from "../../utils/api";

import API_URL from "../../config";
const Resetpassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    if (!token) {
      setError("Invalid or expired reset link");
    }
  }, [token]);
  const passwordValidation = (password) => {
    const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}$/;
    return regex.test(password);
  };
  const handleResetPassword = async () => {
    setMessage("");
    setError("");
    if (newPassword !== confirmPassword) {
      setError("Passwords donot match");
      return;
    }
    if (!passwordValidation(newPassword)) {
      setError(
        "Password must be atleast 8 characters long and include an uppercase letter, a lowercase letter, a number and a special character."
      );
      return;
    }
    try {
      await axios.post(`${API_BASE_URL}/auth/reset-password`, {
        token,
        newPassword,
      });
      setMessage("Password reset successfully. You can login");
      setTimeout(() => navigate("/login"), 3000);
    } catch (err) {
      setError(err.response?.data?.error || "Password reset failed");
    }
  };
  return (
    <Container maxWidth="xs">
      <Card sx={{ mt: 8, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h4" align="center" gutterBottom>
            Reset Password
          </Typography>

          {message && (
            <Alert severity="success" sx={{ mb: 2 }}>
              {message}
            </Alert>
          )}
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <TextField
            label="New Password"
            type="password"
            variant="outlined"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
            label="Confirm New Password"
            type="password"
            variant="outlined"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            fullWidth
            sx={{ mb: 2 }}
          />
          <Button
            variant="contained"
            color="primary"
            sx={{ textTransform: "none" }}
            fullWidth
            onClick={handleResetPassword}
            disabled={!(confirmPassword.length > 0 && newPassword.length > 0)}
          >
            Save New Password
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ textTransform: "none" }}
            fullWidth
            onClick={() => navigate("/login")}
          >
            Cancel
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
};
export default Resetpassword;
